/**
 * @generated SignedSource<<cc0d0a9ce5a5acd668f9c5a6b495e53f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type InternJobsHealthQuery$variables = {};
export type InternJobsHealthQuery$data = {
  readonly internJobHealthMetrics: {
    readonly avgDurationMs: number | null;
    readonly failureCount: number;
    readonly failuresLastHour: number;
    readonly jobsLastHour: number;
    readonly retryCount: number;
    readonly runningCount: number;
    readonly successCount: number;
    readonly successRate: number;
    readonly totalJobs: number;
  };
  readonly internJobTaskNames: ReadonlyArray<{
    readonly count: number;
    readonly failureCount: number;
    readonly successCount: number;
    readonly taskName: string;
  }>;
};
export type InternJobsHealthQuery = {
  response: InternJobsHealthQuery$data;
  variables: InternJobsHealthQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "successCount",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "failureCount",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "hours",
        "value": 24
      }
    ],
    "concreteType": "JobHealthMetrics",
    "kind": "LinkedField",
    "name": "internJobHealthMetrics",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalJobs",
        "storageKey": null
      },
      (v0/*: any*/),
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "runningCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "retryCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "successRate",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "avgDurationMs",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "jobsLastHour",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "failuresLastHour",
        "storageKey": null
      }
    ],
    "storageKey": "internJobHealthMetrics(hours:24)"
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "TaskNameCount",
    "kind": "LinkedField",
    "name": "internJobTaskNames",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "taskName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "count",
        "storageKey": null
      },
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "InternJobsHealthQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "InternJobsHealthQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "7b4b7d2df459cacf7d5ca67d12b93a10",
    "id": null,
    "metadata": {},
    "name": "InternJobsHealthQuery",
    "operationKind": "query",
    "text": "query InternJobsHealthQuery {\n  internJobHealthMetrics(hours: 24) {\n    totalJobs\n    successCount\n    failureCount\n    runningCount\n    retryCount\n    successRate\n    avgDurationMs\n    jobsLastHour\n    failuresLastHour\n  }\n  internJobTaskNames {\n    taskName\n    count\n    successCount\n    failureCount\n  }\n}\n"
  }
};
})();

(node as any).hash = "613418d6b1d1d639a489baaeb132353b";

export default node;
